import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  infoWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  groupTitle: {
    fontWeight: '700',
    fontSize: 16,
    color: '#003353',
    marginBottom: 20,
  },
  label: {
    color: '#668598',
    fontSize: 16,
    lineHeight: 24,
  },
  labelInfo: {
    color: '#335C75',
    fontSize: 16,
    lineHeight: 24,
    fontWeight: '500',
    maxWidth: 250,
    textAlign: 'right',
  },
  underline: {
    width: '100%',
    height: 1,
    backgroundColor: '#EBEEEF',
    marginBottom: 20,
  },
  notesHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  notesTitle: {
    color: '#335C75',
    fontWeight: '500',
    lineHeight: 24,
    fontSize: 16,
  },
  addNoteButton: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  addNoteLabel: {
    color: '#00A0F3',
    fontSize: 16,
    lineHeight: 24,
    marginLeft: 8,
  },
  emptyNotesLabel: {
    color: '#668598',
    fontSize: 14,
    lineHeight: 24,
  },
  textArea: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#007FCF',
    borderRadius: 4,
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4,
    color: '#3E4756',
    fontSize: 16,
    lineHeight: 24,
  },
  saveButton: {
    alignSelf: 'flex-end',
    marginTop: 6,
  },
  saveLabel: {
    color: '#00A0F3',
    fontSize: 16,
    fontWeight: '600',
    lineHeight: 24,
  },
  savedNotesContainer: {
    width: '100%',
    marginTop: 32,
  },
  savedNotesText: {
    color: '#3E4756',
    fontSize: 16,
    lineHeight: 24,
  },
  breakLine: {
    width: '100%',
    height: 1,
    marginTop: 12,
    backgroundColor: 'rgba(167, 177, 195, 0.6)',
    marginBottom: 10,
  },
  bottomContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  date: {
    color: '#828C9D',
    fontSize: 14,
    lineHeight: 17,
  },
  deleteNote: {
    color: '#D24E45',
    fontSize: 14,
    lineHeight: 17,
  },
})
export default styles
